import { RequestMiddleware } from '../types'
import { appVersionReqMiddleware } from './appVersionReqMiddleware'
import { cachedRedirectEnvelopeReqMiddleware } from './cachedRedirectEnvelopeReqMiddleware'
import { contentTypeReqMiddleware } from './contentTypeReqMiddleware'

export const AVAILABLE_REQUEST_MIDDLEWARE_ORDER = [
  'contentType',
  'authHeader',
  'appVersion',
  'cachedRedirectEnvelope',
] as const
type RequestMiddlewareType = (typeof AVAILABLE_REQUEST_MIDDLEWARE_ORDER)[number]

export const useInjectAdditionalFetchMiddleware = () => {}

export const fetchRequestMiddleware: Map<RequestMiddlewareType, RequestMiddleware> = new Map()
fetchRequestMiddleware.set('contentType', contentTypeReqMiddleware)
fetchRequestMiddleware.set('appVersion', appVersionReqMiddleware)
fetchRequestMiddleware.set('cachedRedirectEnvelope', cachedRedirectEnvelopeReqMiddleware)
